import type { ComponentProps } from "react";
import { Button as AriaButton } from "react-aria-components";
import External from "src/design-system/icons/External.svg?react";
import { iconSize } from "src/design-system/tokens/iconSize";
import { PromoPreviewContainer } from "../SearchPromoPreviewContainer";

type CarOptionProps = {
  onPress: ComponentProps<typeof AriaButton>["onPress"];
  srcSet: {
    webp: string;
    fallback: string;
  };
  label: string;
};

export function CarOption(props: CarOptionProps) {
  return (
    <PromoPreviewContainer onPress={props.onPress}>
      <picture className="relative flex items-center justify-center rounded-lg bg-neutral-600 p-3 group-hover:brightness-90 group-active:brightness-90 lg:h-32">
        <source srcSet={props.srcSet.webp} type="image/webp" sizes="150px" />
        <img
          src={props.srcSet.fallback}
          alt=""
          className="select-none"
          draggable="false"
          loading="lazy"
          srcSet={props.srcSet.fallback}
          sizes="150px"
          width={150}
          height={90}
        />
      </picture>
      <div className="absolute top-2 left-2 hidden rounded-md bg-white p-2 shadow-md group-hover:block">
        <External width={iconSize.md} height={iconSize.md} />
      </div>
      <h3 className="text-label-lg font-semibold">{props.label}</h3>
    </PromoPreviewContainer>
  );
}
